import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useThemeStore = create(
  persist(
    (set, get) => ({
      // State
      theme: 'system', // 'light', 'dark', 'system'
      isDark: false,

      // Actions
      setTheme: (newTheme) => {
        set({ theme: newTheme });
        get().applyTheme(newTheme);
      },

      toggleTheme: () => {
        const { theme } = get();
        const newTheme = theme === 'light' ? 'dark' : 'light';
        get().setTheme(newTheme);
      },

      applyTheme: (theme) => {
        const root = document.documentElement;
        
        if (theme === 'system') {
          const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
          root.setAttribute('data-theme', prefersDark ? 'dark' : 'light');
          if (prefersDark) {
            root.classList.add('dark');
          } else {
            root.classList.remove('dark');
          }
          set({ isDark: prefersDark });
        } else {
          root.setAttribute('data-theme', theme);
          if (theme === 'dark') {
            root.classList.add('dark');
          } else {
            root.classList.remove('dark');
          }
          set({ isDark: theme === 'dark' });
        }
      },

      initializeTheme: () => {
        const { theme } = get();
        get().applyTheme(theme);

        // Listen for system theme changes
        if (theme === 'system') {
          const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
          const handleChange = (e) => {
            if (get().theme === 'system') {
              get().applyTheme('system');
            }
          };
          
          mediaQuery.addEventListener('change', handleChange);
          
          // Cleanup function
          return () => mediaQuery.removeEventListener('change', handleChange);
        }
      }
    }),
    {
      name: 'theme-storage',
      partialize: (state) => ({
        theme: state.theme
      })
    }
  )
);

export default useThemeStore;
